import "./heroimgStyle.css";
import React from 'react'
import IntroImg from "../../assets/2.jpg";
import { Link} from "react-router-dom";
import Typical from 'react-typical'

const Heroimg = () => {
  return (
    <div className="hero">
    <div className="mask">
        <img className ="into-img" src ={IntroImg} alt ="intro img"/>
    </div>
    <div className="content">
        <p>Hello, I,M <span className="namecol"><b>HRITIK SHUKLA</b></span></p>
        <h1>I, M A <space></space>
        <Typical className="namecol2"
        loop ={Infinity}
        wrapper="h"
        steps ={[
          ' Developer... ',
          1000,
          ' Web Designer... ',
          1000,
          ' Coder... ',
          1000,
          ' You Tuber...',
          1000



        ]}
        >
        
        </Typical>
        </h1>
        <div>
            <Link to="/project" className="btn">Projects</Link>
            <Link to="/contact" className="btn-light">Contact</Link>

        </div>
    </div>
    </div>
  )
}

export default Heroimg